import React, {} from "react"
import '../../../css/InfluencerUpload.css'
import make_content_with_overlay from './make_content_with_overlay';

export default function make_single_influencer_row(content_row, content_array_name, data_func, n_col = 3) {
   return content_row.map(
      (content_info, content_index) => {
         var n_col_col = n_col + '_col'
         var block_class_name = "grid_div" + content_info[n_col_col];
         var block_content_with_overlay = make_content_with_overlay(content_info, "content_info_scroll_content")
         var block_content_info_bar = this.make_block_content_info(content_info, content_array_name, data_func, false);
         var influencer_href = "/content/" + content_info['id'];
         return (
            <a href={influencer_href}>
               <div className={block_class_name}>
                  {block_content_with_overlay}
                  {block_content_info_bar}
               </div>
            </a>
         )
      }
   )
}
